// shareCodeRow.js — PROD-941 (Alex 2026-10-12 Q20 (c)): the manage sheet's "Generate new share
// code" row is hidden on a case a physician holds or was sent. Import-free, so
// scripts/check-share-code-row.mjs executes it.
//
// ★★ THE DEFECT. On such a case the row could never work: the API refuses both halves of the
//   regenerate (orella-api api/index.py generate_share_code — the `renew: true` branch answers
//   409 share_code_not_renewable, and the PROD-509 mint pre-check answers 409
//   share_code_not_mintable), and handleRegenerateCode itself stops before the revoke (SCW-9).
//   The patient kept the code but read "Your code could not be renewed right now. Please try
//   again later." — and trying later never helps there.
//
// ★★ THE CONDITION IS THE SERVER'S, MIRRORED. generate_share_code refuses when
//       _owner_row.get('target_doctor_id') or _owner_row.get('doctor_id')
//   The mapped case carries neither column; the store maps them (stores/index.js loadCases) as
//       sentToDoctor: c.target_doctor_id || c.doctor_id     (the same union)
//       heldByDoctor: !!c.doctor_id                         (a subset of it)
//   Both are read, and so are the raw / camel spellings handleRegenerateCode's server-row check
//   accepts, in case a case object carries them. Nothing else (a doctor's name, a status) is read:
//   the row is hidden exactly where the server refuses for a physician, and nowhere else.
export function isWithPhysician(c) {
  if (!c || typeof c !== 'object') return false
  return !!(c.sentToDoctor || c.heldByDoctor === true
    || c.target_doctor_id || c.doctor_id || c.targetDoctorId || c.doctorId)
}

// The row is offered only on a case the server would renew or re-mint a code for.
export function offersNewShareCode(c) {
  return !!c && typeof c === 'object' && !isWithPhysician(c)
}
